package api.org.ssoft.server.common.rss

import api.*
import api.org.ssoft.server.common.rss.Io.ImplRssChannel.ImplItem
import kotlinx.datetime.*
import kotlinx.serialization.*
import org.ssoft.common.tools.*


object Io {

//    @Serializable
//    data class Rss(
//        var channel: Channel = Channel()
//    )

    @Serializable
    data class Rss(
        var url: String = "",
        var item: List<RssEntry> = listOf()
    )

    @Serializable
    data class RssEntry(
        var sort: Int = 0,
        var guid: String = "",
        var title: String = "",
        var link: String = "",
        var description: String = "",
        var rawTitle: String = title,
        var rawDesc: String = description,
        var category: String = "",
        var author: String = "",
        var pubDate: LocalDateTime = LocalDateTime.EMPTY,
        var changeDate: LocalDateTime = LocalDateTime.EMPTY,
        var endDate: LocalDateTime = LocalDateTime.EMPTY,
        var enclosure: MutableList<MediaItem> = mutableListOf(),
        var content: MediaItem = MediaItem(),
    )

    @Serializable
    data class MediaItem(
        var type: String = "",
        var name: String = "",
        var url: String = "",
        var description: String = "",
        var resourceType: Int = ResourceType.UNDEFINED.mask
    )


    interface ImplRssChannel<I : ImplItem<R>, R : ImplRssChannel.ImplRes> {
        var id: Long
        var change: LocalDateTime
        var items: List<I>

        interface ImplItem<R : ImplRes> {
            var id: Long
            var link: String
            var title: String
            var description: String
            var rawTitle: String
            var rawDesc: String
            var category: String
            var author: String
            var publish: LocalDateTime
            var change: LocalDateTime
            var end: LocalDateTime
            var image: Long
            var sort:Int
            var res: List<R>
        }

        interface ImplRes {
            var id: Long
            var name: String

            /** @see ResourceType */
            var type: Int
        }
    }
}
